import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const loginAdmin = createAsyncThunk(
  "auth/loginAdmin",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${apiUrl}/api/login/`, {
        username,
        password,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Network error" });
    }
  }
);

// Server-side logout: revokes the token row, then the reducer clears local state.
// We swallow request errors because the token may already be invalid/expired —
// either way we want the client to end up logged out.
export const logoutAsync = createAsyncThunk(
  "auth/logoutAsync",
  async (_, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      try {
        await axios.post(
          `${apiUrl}/api/logout/`,
          {},
          { headers: { Authorization: `Token ${token}` } }
        );
      } catch (_) {
        /* token may already be dead; we still want to clear local state */
      }
    }
  }
);

const initialState = {
  isAuthenticated: false,
  token: null,
  user: null,
  isAdmin: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: () => initialState,
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAdmin.pending, (state) => {
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.isAuthenticated = true;
        state.token = action.payload.token;
        state.user = action.payload.user;
        state.isAdmin = Boolean(action.payload.is_admin);
        state.error = null;
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.error = action.payload || "Failed to log in";
      })
      .addCase(logoutAsync.fulfilled, () => initialState)
      .addCase(logoutAsync.rejected, () => initialState);
  },
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
